import React from 'react';

const TagIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.1587 11.1748L11.1837 17.1498C11.0289 17.3048 10.8451 17.4277 10.6427 17.5116C10.4404 17.5955 10.2235 17.6386 10.0045 17.6386C9.78547 17.6386 9.56859 17.5955 9.36626 17.5116C9.16393 17.4277 8.98011 17.3048 8.82533 17.1498L1.66699 9.99984V1.6665H10.0003L17.1587 8.82484C17.4691 9.13711 17.6433 9.55953 17.6433 9.99984C17.6433 10.4401 17.4691 10.8626 17.1587 11.1748V11.1748Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.8335 5.83301H5.84121"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default TagIcon;
